import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import {useDispatch, useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Column,
  Row,
  Wrapper,
  WrapperCard,
  WrapperContent,
  WrapperSubHeader,
} from "../../../components/common";
import ContactFormAccordian from "../../../components/common/Accordian/ContactFormAccordian";
import BreadCrumbComponent from "../../../components/common/BreadCrumbComponent/BreadCrumbComponent";
import GeneralDetailsFormComponent from "../../../components/common/FormComponent/Contact/GeneralDetailsFormComponent";
import { axiosFunction } from "../../../components/commonFunctions/axiosFunction"
import useResponsive from "../../../hooks/useResponsive";
import Footer from "../../../layout/footer/Footer";
import { v2ReactURL } from "../../../utils/constant";
import { DateFormat } from "../../../utils/DateFormat";
import { AddContactContainer } from "./AddContactContainer";
import AddressDetailsFormNew from "../../../components/common/FormComponent/Contact/AddressDetailFormNew";
import ErrorPage from "../../Error/ErrorPage";
import Loader from "../../../utils/Loader";
import useContactValidation from "../../../hooks/useContactValidation";
import { gstType, GstValidMsg, showVerifyBtn } from '../../../components/common/FormComponent/Contact/FormComponentSchema';
import { ContactEditSchema, ContactEditType } from "../EditContact/EditContactSchema";
import { AddressDetails, EditAndAddContactType, formAdditiondetailsObj } from "../EditContact/EditAndAddContactSchema";
import {resetPhoneNo} from "../../../store/Contact/phoneNoSlice.ts";
import { useToggleContext } from "../../../layout/ToggleContext.tsx";

export interface ErrorState {
  code: string;
  message: string;
}

const AddContact = () => {
  const phoneNo = useSelector((state: any) => state.phoneNo);
  const contactType = useSelector((state: any) => state.contactType);
  const [error, setError] = useState<ErrorState | null>(null);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedGSTType, setSelectedGSTType] = useState<gstType>({
    value: "UnRegistered",
    label: "UnRegistered",
  });
  const { isToggle } = useToggleContext();


  const [isLoading, setLoading] = useState<boolean>(true);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [showVerifyBtn, setShowVerifyBtn] = useState<showVerifyBtn>({});
  const [gstValidMsg, setGstValidMsg] = useState<GstValidMsg>({});
  const [newContactCreatedDetail, setNewContactCreatedDetail] = useState<Partial<ContactEditType>>({});
 


  useEffect(() => {
    const fetchNewContactDetail = async () => {
      const res = await axiosFunction(
        `${v2ReactURL}/contact/new?type=${contactType}`,
        "GET"
      );

      if (res?.status === 200) {
        if (res?.data) {
          const parsedResult = ContactEditSchema.safeParse(res.data);

          if (!parsedResult.success) {

            console.error("Parsing error:", parsedResult.error.format());

          } else {
            setNewContactCreatedDetail(res?.data);



          }
        } else {
          console.error("Response data is null or undefined.");
        }
        setLoading(false);
        if (res?.data?.viewname == "accessdenied/accessdenied") {
          setError({
            code: "200",
            message:
              "Sorry, this area's VIP only. Your pass must've gotton lost in the mail.",
          });
        }


      }
    };
    fetchNewContactDetail();



  }, []);

  const {
    CustomerValidationSchema,
    SupplierValidationSchema,
    TransportValidationSchema,
  } = useContactValidation(0);

  const typeWiseValidationSchema =
    contactType === "customers"
      ? CustomerValidationSchema
      : contactType === "suppliers"
        ? SupplierValidationSchema
        : TransportValidationSchema;

  const accountGroup = newContactCreatedDetail?.AccountGroupData?.find(
    (acc) => acc.isDefault === 1
  );

  const accountGrpDefaultValue = {
    label: `${accountGroup?.accountGroupName || ""} (${accountGroup?.parentGroup || ""})`,
    value: newContactCreatedDetail?.AccountGroupData?.find((acc) => acc.isDefault === 1)?.accountGroupId ?? null,
  };


  const {
    register,
    handleSubmit,
    resetField,
    formState: { errors },
    setValue,
    control,
    watch,
    getValues,
  } = useForm<formAdditiondetailsObj>({
    defaultValues: {
      accountGroupId: accountGrpDefaultValue,
      mobNo: null,
      panNo: null,
      tanNo: null,
      vatNo: null,
      bankIfsc: null,
      firstName: "",
      companyName: null,
      bankAcNo: null,
      customerTaxType:"gst",
      // paymentTermId: "",
      bankBranch: null,
      code: null,
      telephone: null,
      email: null,
      whatsappNo: null,
      transporterId: null,
      remark: null,
      debitAmount:null,
      lastName: null,
      addressDetails: [
        {
          gstType: { value: "UnRegistered", label: "UnRegistered" },
          contactFirstName: "",
         contactCompanyName: "",
          contactLastName: "",
          mobNo: null,
          contactEmail: "",
          addressLine1: null,
          addressLine2: null,
          countriesCode: {
            value: sessionList?.countryCode || "IN",
            label: sessionList?.countryName || "India",
          },
          state: {
            value: sessionList?.stateCode || "24",
            label: sessionList?.stateName || "Gujarat",
          },
          city: {
            value: sessionList?.cityCode || "938",
            label: sessionList?.cityName || "Ahmedabad",
          },


          pincode: null,
          GSTIN: "",
        },
      ],
    },
    resolver: yupResolver(typeWiseValidationSchema as any),
    mode: "onChange",
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "addressDetails",
  });

  const contactAddressVos = (data: EditAndAddContactType) => {
    return data?.addressDetails?.map((addressData: AddressDetails, index: number) => {
      // console.log("datadatadatadata",data.addressDetails)
      return {
        gstType: addressData?.gstType?.value,
        firstName: addressData?.contactFirstName,
        lastName: addressData?.contactLastName,
        companyName: addressData?.contactCompanyName,
        countryDialCodePrefix: phoneNo?.prefixes[
          `addressDetailsmobNo[${index}]`
        ]
          ? `+${phoneNo?.prefixes[`addressDetailsmobNo[${index}]`]}`
          : "+91",
        phoneNo: addressData?.mobNo,
        email: addressData?.contactEmail,
        addressLine1: addressData?.addressLine1,
        addressLine2: addressData?.addressLine2,
        countriesCode: addressData?.countriesCode?.value,
        stateCode: addressData?.state?.value,
        cityCode: addressData?.city?.value,
        pinCode: addressData?.pincode,
        contactAddressId: 0,
        isDefault: 0,
        countriesName: addressData?.countriesCode?.label,
        stateName: addressData?.state?.label,
        cityName: addressData?.city?.label,
        gstin: addressData?.GSTIN,
      };
    });
  };

  const whatsappPrefix = phoneNo?.prefixes?.whatsappNo
    ? `+${phoneNo.prefixes.whatsappNo}`
    : "";
  const mobNoPrefix = phoneNo?.prefixes?.mobNo
    ? `+${phoneNo.prefixes.mobNo}`
    : "";

  const typeWiseContact = (data: EditAndAddContactType) => {
    return contactType === "customers"
      ? data.customerType
      : contactType === "suppliers"
        ? data.supplierType
        : "";
  };

  const payloadData = (data: formAdditiondetailsObj, createnew: number, createinvoice: number, preview: number) => {
    return {
      type: contactType,
      contactType: typeWiseContact(data),
      imgLocation: "",
      deleteAddress: [],
      createnew: createnew,
      createinvoice: createinvoice,
      preview: preview,
      contactId: 0,
      isBranch: 0,
      accountCustomVo: {
        accountCustomId: 0,
      },
      shopifySourceId: 0,
      deletecontactProductIds: "",
      hiddenSessionCountryCode: "IN",
      oldMemberShipid: 0,
      accountGroupId:
        data?.accountGroupId?.value || accountGrpDefaultValue.value,
      firstName: data.firstName,
      lastName: data.lastName,
      companyName: data.companyName,
      supplierCode: contactType !== "transport" ? data.code : "",
      email: data.email,
      countryDialCodePrefix: mobNoPrefix,
      mobNo: data.mobNo,
      panNo: data.panNo,
      telephone: data.telephone,
      remark: data.remark,
      creditLimit: data.creditAmount,
      creditAmount: data.creditAmount,
      debitAmount: data.debitAmount,
      ...(data?.paymentTermId?.value && {
        paymentTermVo: {
          paymentTermId: data.paymentTermId.value || 0,
        },
      }),
      tanNo: data.tanNo || "",
      vatNo: data.vatNo || "",
      countryDialCodePrefixWhatsapp: whatsappPrefix,
      whatsappNo: data.whatsappNo,
      dateOfBirth1: DateFormat(data.dateOfBirth1),
      anniversaryDate1: DateFormat(data.anniversaryDate1),
      customerCategoryName:
        data?.customerCategoryId?.customerCategoryName || "",
      customerCategoryId: data?.customerCategoryId?.customerCategoryId,
      ...(data?.membershipId?.membershipId && {
        memberShipMasterVo: { membershipId: data?.membershipId?.membershipId },
      }),
      transporterId: data.transporterId,
      commission: 0.0,
      contact_type: data.customerType,
      bankIfsc: data.bankIfsc || "",
      bankName: data.bankName || "",
      bankBranch: data.bankBranch || "",
      bankAcNo: data.bankAcNo || "",
      contactAddressVos: contactAddressVos(data),
    };
  };



  const onSave = async (data: formAdditiondetailsObj) => {
    setIsLoadingBtn(true);
    if(data.whatsappNo === null || data.whatsappNo === "")  {
      setValue("whatsappNo", data.mobNo);
    }
    
    try {
      const response = await axiosFunction(
        `${v2ReactURL}/contact/insert`,
        "POST",
        payloadData(data, 0, 0, 0)
      );

      if (response.data.status) {
        navigate(
          `/reactcontact/${contactType}/${response.data.response.ContactId}`
        );
      }
    } catch (error) {
      console.error("Error saving contact:", error);
    } 
  };
  const onCreateNewSave = async (data: formAdditiondetailsObj) => {
    if(data.whatsappNo === null || data.whatsappNo === "")  {
      setValue("whatsappNo", data.mobNo);
    }
    setIsLoadingBtn(true);
    try {
      const response = await axiosFunction(
        `${v2ReactURL}/contact/insert`,
        "POST",
        payloadData(data, 1, 0, 0)
      );
  
      if (response.data.status) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error:", error);
    } 
  };
  


  const onCreateInvoiceSave = async (data: formAdditiondetailsObj) => {
    if(data.whatsappNo === null || data.whatsappNo === "")  {
      setValue("whatsappNo", data.mobNo);
    }
    if (isLoadingBtn) return; // Prevents multiple calls

    setIsLoadingBtn(true);
    try {
      const response = await axiosFunction(
        `${v2ReactURL}/contact/insert`,
        "POST",
        payloadData(data, 0, 1, 0)
      );

      if (response.data.status) {
        const redirectLink = response.data.response.LINK;
        window.location.href = redirectLink;
      } else {
        setIsLoadingBtn(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsLoadingBtn(false);
    }
  };
  

  const onPreviewSave = async (data: formAdditiondetailsObj) => {
    if(data.whatsappNo === null || data.whatsappNo === "")  {
      setValue("whatsappNo", data.mobNo);
    }
    setIsLoadingBtn(true);
    const response = await axiosFunction(
      `${v2ReactURL}/contact/insert`,
      "POST",
      payloadData(data, 0, 0, 1)
    );

    if (response.data.status) {
      navigate(
        `/reactcontact/${contactType}/${response.data.response.ContactId}`
      );
    }
    else {
      setIsLoadingBtn(false);
    }
  };

  useEffect(() => {
    setValue("accountGroupId", accountGrpDefaultValue);
  }, [newContactCreatedDetail]);

  const resetFormFields = () => {
    setValue("customerType", "wholesaler");
    setValue("mobNo", "");
    setValue("whatsappNo", "");
    setValue("membershipId", { membershipId: null, label: null });
    setValue("customerCategoryId", {
      value: 0,
      label: "Customer Category",
    })
    setValue("paymentTermId", {
      label: "Select Payment Term",
      value: null
    }
    );
    resetField("firstName");
    // resetField("paymentTermId");
    resetField("lastName");
    resetField("companyName");
    resetField("code");
    resetField("telephone");
    resetField("email");
    resetField("panNo");
    resetField("tanNo");
    resetField("dateOfBirth1");
    resetField("anniversaryDate1");
    resetField("debitAmount");
    resetField("creditAmount");
    resetField("remark");
    resetField("bankName");
    resetField("bankBranch");
    resetField("bankAcNo");
    resetField("bankIfsc");
    resetField("transporterId");

    resetField("addressDetails");
  };

  const handleClear = () => {
    resetFormFields();
  };
  const isMobile = useResponsive();

  const handleBlurFirstName = () => {
    const firstNameValue = watch("firstName");
    const index = 0;
    // console.log("xcfghj",firstNameValue)
    // setValue(`addressDetails.${index}.contactFirstName`, firstNameValue ?? "");
    setValue(`addressDetails.${index}.contactFirstName`, firstNameValue ?? "", {
      shouldValidate: true,
      shouldDirty: true,    
      shouldTouch: true,    
    });
  };

  const handleBlurLastName = () => {
    const lastNameValue = watch("lastName");
    const index = 0;
    // setValue(`addressDetails.${index}.contactLastName`, lastNameValue?? "");
    setValue(`addressDetails.${index}.contactLastName`, lastNameValue ?? "", {
      shouldValidate: true,
      shouldDirty: true,    
      shouldTouch: true,    
    });
  };

  const handleBlurCreditAmount = () => {
    if (!!getValues("creditAmount")) {
      setValue("debitAmount", null , {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  };

  const handleBlurDebitAmount = () => {
    if (!!getValues("debitAmount")) {
      setValue("creditAmount", null , {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  };
  const handleBlurCompanyName = async () => {
    const companyNameValue = watch("companyName");
    const words = companyNameValue && companyNameValue.split(" ");
    const initials = words && words.map((word) => word.charAt(0).toUpperCase()).join("");
    if (initials && !(contactType === "transport")) {
      const supplierCode = await axiosFunction(
        `${v2ReactURL}/contact/${contactType}/code?code=${initials}&contactId=${0}`,
        `POST`,
      )
      setValue("code", supplierCode.data, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      
    } else {
      setValue("code", "", {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
      
    }
    const index = 0;
    setValue(`addressDetails.${index}.contactCompanyName`, companyNameValue ?? "", {
      shouldValidate: true,
      shouldDirty: true,    
      shouldTouch: true,    
    });
  };
  

  const handleBlurContactNo = () => {
    const numberValue = watch("mobNo");
    setValue(`whatsappNo`, numberValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  useEffect(()=>{
   localStorage.removeItem("pinCodes")
  },[newContactCreatedDetail])

  const capitalizeFirstChar = (string: string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (isLoading) {
    return <Loader />;
  }
  const customerTaxType = watch("customerTaxType");
  return (
   
      <Wrapper
        navUrl={`${"New Contact"}`}
        customStyle={{ height: "auto" }}
        subClassName={"addContactWrapper"}
      >
        <WrapperSubHeader>
          <Column md={8}></Column>
          <Column md={2}></Column>
          <Column md={2} className="pl-md-0 mt-1 mt-md-0"></Column>
        </WrapperSubHeader>
        <AddContactContainer>
          <WrapperContent>
            <BreadCrumbComponent
              type={`${capitalizeFirstChar(contactType)}  `}
              subType={`${"Create " + capitalizeFirstChar(contactType)}`}
              subTypeClickable={false}
            />
            <Row>
              <WrapperCard>
                <ContactFormAccordian
                  generalDetailsForm={
                    <GeneralDetailsFormComponent
                      newContactCreatedDetail={newContactCreatedDetail}
                      register={register}
                      errors={errors}
                      control={control}
                      setValue={setValue}
                      customerTaxType={customerTaxType}
                      // accountGrpDefaultValue={accountGrpDefaultValue}
                      handleBlurFirstName={handleBlurFirstName}
                      handleBlurLastName={handleBlurLastName}
                      handleBlurCompanyName={handleBlurCompanyName}
                      handleBlurContactNo={handleBlurContactNo}
                      handleBlurCreditAmount={handleBlurCreditAmount}
                      handleBlurDebitAmount={handleBlurDebitAmount}
                    />
                  }
                  addressDetailsForm={
                    <AddressDetailsFormNew
                      setSelectedGSTType={setSelectedGSTType}
                      selectedGSTType={selectedGSTType}
                      control={control}
                      customerTaxType={customerTaxType}
                      errors={errors}
                      register={register}
                      newContactCreatedDetail={newContactCreatedDetail}
                      fields={fields}
                      append={append}
                      remove={remove}
                      setValue={setValue}
                      getValues={getValues}
                      setShowVerifyBtn={setShowVerifyBtn}
                      showVerifyBtn={showVerifyBtn}
                      setGstValidMsg={setGstValidMsg}
                      gstValidMsg={gstValidMsg}
                    />
                  }
                />
              </WrapperCard>
            </Row>
          </WrapperContent>
        </AddContactContainer>
        <div
          style={{
            position: "fixed",
            bottom: 0,
            width: `calc(100% - ${isToggle ? 78 : 230}px)`,
            zIndex: 999999999999,
            left: isMobile ? 0 : isToggle ? 78 : 230
            // left: isMobile ? 0 : "",
          }}
        >
          <Footer
            onSubmit={handleSubmit(onSave)}
            handleClear={handleClear}
            onCreateInvoiceSave={handleSubmit(onCreateInvoiceSave)}
            onCreateNewSave={handleSubmit(onCreateNewSave)}
            onPreviewSave={handleSubmit(onPreviewSave)}
            clearBtn={true}
            addressDetailsError={false}
            isLoading={isLoadingBtn} // Pass loading state
            onCancelClick={() => {
              dispatch(resetPhoneNo());
              navigate("/reactcontact");
            }}
          />

        </div>
      </Wrapper>
    
  );
};

export default AddContact;
